import { render, staticRenderFns } from "./TransportPaymentEdit.vue?vue&type=template&id=9583e388"
import script from "./TransportPaymentEdit.vue?vue&type=script&lang=js"
export * from "./TransportPaymentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports